import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from "@progress/kendo-react-layout";
import {
  Scheduler,
  AgendaView,
  DayView,
  WeekView,
  MonthView,
  WorkWeekView,
  SchedulerItem,
  SchedulerHeader,
  SchedulerFooter,
} from "@progress/kendo-react-scheduler";
import EventDateService from "../../services/srv-event/EventDateService";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";
import { loadMessages } from "@progress/kendo-react-intl";
import i18n from "../../config/languageInit";

loadMessages(i18n.store.data[i18n.language], i18n.language);

function HomeScheduler(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    EventDateService.getList().then((data) => {
      setLoading(false);
      setData(
        data.map((item) => {
          return {
            id: item.etkinliK_TARIH_ID,
            title: item.etkinliK_ADI,
            start: item.baS_TAR ? new Date(item.baS_TAR) : new Date(),
            end: item.biT_TAR ? new Date(item.biT_TAR) : new Date(),
            color: item.renK_KODU,
          };
        })
      );
    });
  };

  const CustomItem = (props) => {
    return (
      <SchedulerItem
        {...props}
        style={{
          ...props.style,
          backgroundColor: props.dataItem.color,
        }}
      />
    );
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("event_calendar")}</CardTitle>
      </CardHeader>
      <CardBody>
        {loading && <LoadingPanel />}
        <Scheduler
          data={data}
          item={CustomItem}
          header={(props) => (
            <SchedulerHeader {...props} style={{ backgroundColor: "white" }} />
          )}
          footer={(props) => (
            <SchedulerFooter {...props} style={{ backgroundColor: "white" }} />
          )}
        >
          <AgendaView />
          <DayView />
          <WeekView />
          <MonthView />
          <WorkWeekView />
        </Scheduler>
      </CardBody>
    </Card>
  );
}

export { HomeScheduler };
